import React from 'react';

export const CheckedIcon = ({ className }) => {
	return (
		<svg width="36" height="26" viewBox="0 0 36 26" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M18 23C23.5228 23 28 18.5228 28 13C28 7.47715 23.5228 3 18 3C12.4772 3 8 7.47715 8 13C8 18.5228 12.4772 23 18 23Z" stroke="#F26C20" stroke-width="2" />
			<path d="M14 13L17 16L22 10" stroke="#F26C20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	);
};
